export const items = [
  {
    name: 'mainMenu',
    position: 'top',
    title: 'Main menu',
    iconClass: 'material-icons',
    iconName: 'format_list_bulleted',
    active: true,
    component: 'DropdownMenu',
    componentProps: {
      items: [],
      id: 'mainmenu',
      searchable: false,
      mainMenu: true,
    },
    helpySelector: 'main-menu',
    badge: true,
  },
  {
    name: 'globalSearch',
    position: 'top',
    title: 'Global search',
    iconClass: 'material-icons',
    iconName: 'search',
    active: true,
    component: 'GlobalSearchMenu',
    componentProps: {},
    helpySelector: 'global-search',
  },
  {
    name: 'bookmark',
    position: 'top',
    title: 'Bookmarks',
    iconClass: 'material-icons',
    iconName: 'bookmark_border',
    component: 'Bookmark',
    active: true,
    componentProps: {},
    helpySelector: 'bookmark',
  },
  {
    name: 'workflow',
    position: 'top',
    title: 'Workflow',
    iconClass: 'material-icons',
    iconName: 'timeline',
    component: 'Workflow',
    active: true,
    componentProps: {},
    helpySelector: 'workflow-menu',
    badge: true,
  },
  {
    name: 'infoButton',
    position: 'top',
    iconClass: 'material-icons',
    iconName: 'info',
    active: true,
    component: 'SubsystemInfo',
    helpySelector: 'system-information',
    title: 'Helpy',
  },
  {
    name: 'voiceControl',
    position: 'bottom',
    iconClass: 'material-icons',
    iconName: 'mic',
    active: true,
    component: 'VoiceControl',
    helpySelector: 'voice-control',
    title: 'Voice control',
  },
  {
    name: 'message',
    position: 'top',
    iconClass: 'material-icons',
    iconName: 'message',
    active: true,
    component: 'InternalMessages',
    helpySelector: 'message-menu',
    badge: true,
    title: 'Messages',
  },
  {
    name: 'aiChat',
    position: 'bottom',
    iconClass: 'material-icons',
    iconName: 'psychology',
    active: true,
    component: 'OpenAiChat',
    helpySelector: 'open-ai',
    title: 'OpenAI',
  },
  {
    name: 'errorReport',
    position: 'bottom',
    iconClass: 'material-icons',
    iconName: 'bug_report',
    active: true,
    component: 'Screenshot',
    helpySelector: 'bug-report',
    title: 'Bug report',
  },
  {
    name: 'menuPosition',
    position: 'bottom',
    iconClass: 'material-icons',
    iconName: 'switch_left',
    action: 'left-right-sidebar',
    active: true,
    helpySelector: 'menu-side-switch',
    title: 'Menu switch',
  },
  {
    name: 'collapseMenu',
    position: 'bottom',
    iconClass: 'material-icons',
    iconName: 'expand_more',
    action: 'collapse-sidebar',
    active: true,
    helpySelector: 'menu-collapse',
    title: 'Collapse menu',
  },
]
